import React, { Component } from 'react';

import { LayoutAlign, LayoutAPI, LayoutJustify } from '@philips-emr/tws-components-api';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { ContainerProvider } from '@philips-emr/tws-core/lib/component';
import { any, arrayOf, node, object, oneOf, oneOfType, size, string, trackList } from '@philips-emr/tws-core/lib/component/prop-types';
import { enumValues, getLostProps, getSlot, propagateData } from '@philips-emr/tws-utils';
import { parseAreas } from '@philips-emr/tws-utils/lib/grid-utils';

import './layout.scss';

function LayoutArea({ uuid, name, children }) {
  const Container = ContainerProvider.provide(this);

  return (
    <Container className="c-layout__area" data-area-name={name} uuid={uuid} style={{ gridArea: name }} slot={name} exclusive>
      {children}
    </Container>
  );
}

LayoutArea.propTypes = {
  uuid: string,
  name: string,
  coord: object,
  children: oneOfType([node, arrayOf(node)]).notEnumerable(),
};

@AwesomeComponent({ type: ComponentType.LAYOUT, api: LayoutAPI })
class Layout extends Component {
  static propTypes = {
    children: oneOfType([node, arrayOf(node)]).notEnumerable(),
    rows: trackList,
    columns: trackList,
    data: any,
    rowGap: size.group('layout'),
    columnGap: size.group('layout'),
    templateAreas: string.group('layout'),
    alignItems: oneOf(enumValues(LayoutAlign)).group('alignment'),
    justifyItems: oneOf(enumValues(LayoutJustify)).group('alignment'),
    alignContent: oneOf(enumValues(LayoutAlign)).group('alignment'),
    justifyContent: oneOf(enumValues(LayoutJustify)).group('alignment'),
    uuid: string,
  };

  static defaultProps = {
    rows: 'auto auto auto',
    columns: 'auto auto auto',
    rowGap: '8px',
    columnGap: '8px',
    alignItems: LayoutAlign.INITIAL,
    justifyItems: LayoutJustify.INITIAL,
    alignContent: LayoutAlign.INITIAL,
    justifyContent: LayoutJustify.INITIAL,
  };

  getStyle() {
    const {
      columns: gridTemplateColumns,
      rows: gridTemplateRows,
      rowGap: gridRowGap,
      columnGap: gridColumnGap,
      templateAreas: gridTemplateAreas,
      alignContent,
      justifyContent,
      alignItems,
      justifyItems,
    } = this.props;

    return {
      gridTemplateAreas,
      gridTemplateRows,
      gridTemplateColumns,
      gridRowGap,
      gridColumnGap,
      alignContent,
      justifyContent,
      alignItems,
      justifyItems,
    };
  }

  renderSlot(slot) {
    const { data, children, ...otherProps } = this.props;
    const lostProps = getLostProps(Layout.propTypes, otherProps);

    const slotChildren = getSlot(children, slot);

    return propagateData(slotChildren, data, lostProps);
  }

  render() {
    const { uuid, children, templateAreas } = this.props;
    const style = this.getStyle();
    const areas = parseAreas(templateAreas);
    const Container = ContainerProvider.provide(this);

    return (
      <Container acceptedTypes={[ComponentType.BEHAVIOR]} uuid={uuid} className="c-layout" style={style}>

        {areas.map((area) => (
          <LayoutArea key={area.name} uuid={uuid} {...area}>
            {this.renderSlot(area.name)}
          </LayoutArea>
        ))}

        {getSlot(children)}

      </Container>
    );
  }
}

export default Layout;
